import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URLS } from '../global';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UpdateZipcodeResponse } from '../models/updateZIpcodeResponse';
import { DevModeService } from './dev-mode.service';

@Injectable({
  providedIn: 'root'
})
export class ZipcodeService {

  constructor(
    private readonly http: HttpClient,
    private readonly devModeService: DevModeService
  ) { }

  updateZipcode(zipcode: string): Observable<UpdateZipcodeResponse> {
    const url = this.devModeService.isDevMode() ? API_URLS.LOCAL + API_URLS.UPDATE_ZIP_CODE : API_URLS.UPDATE_ZIP_CODE;

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    return this.http.post<UpdateZipcodeResponse>(url, { zipcode: zipcode }, { headers: headers });
  }

  // validateZipCode(zipcode: string | null): Observable<UpdateZipcodeResponse> {
  //   const url = this.devModeService.isDevMode() ? API_URLS.LOCAL + API_URLS.VALIDATE_ZIPCODE : API_URLS.VALIDATE_ZIPCODE;
  //   return this.http.get<UpdateZipcodeResponse>(`${url}?zipcode=${zipcode}`);
  // }

}
